<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_LOGIN_ID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.loginId"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.userName"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EPNO')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.employeeIDNumber"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_GLBL_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.userGlobalName"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <ur-data-grid
        ref="grid"
        :headers="columns"
        :data-source="newDataSet"
        :options="options"
        @grid:row-click="onRowSelect"
      >
        <!-- infinity scroll용 dropdown
        (dropdown은 pagination 종속적이라 pagination의 경우 필요없음) -->
        <template #left-info>
          <ur-dropdown
            class="ur-data-grid__info__per-page"
            :items="items"
            v-model="rowsPerPage"
            @input="onPageSizeChange"
          />
        </template>
        <template #right-info>
          <sui-button
            class="comm_btn_gridTop comm_ico_excel"
            @click="onExcelDownloadClick"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>          
        </template>
      </ur-data-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedGridRowData="selectedGridRowData"
          @onSearchClick="onSearchClick"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import {urDataSet} from 'uidev-component/index.js';
import tab01 from './components/PGE_CMY_00037_T01.vue';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

// infinity scroll 관련 상수
const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;

export default {
  name: 'PGE_CMY_00037',
  components: {
    tab01,
    urDataGrid,
  },
  extends: BasePage,
  data() {
    return {
      newDataSet : new urDataSet(),
      // pagination용 options
      // options: {
      //   pagination     : true,
      //   internalPaging : true,
      //   defaultPageSize: 5,
      //   pagingList     : [5, 10, 15],
      // },
      // infinity scroll용 options
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
        height: DEFAULT_ROWS_PER_PAGE * DEFAULT_ROW_HEIGHT,
      },
      // infinity scroll
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      columns : [
        {
          value:'userId',
          text:'사용자 ID',
          key:true,
          customStyle: {'text-decoration': 'underline'},
          click:(value, row) => {
            this.onDetailClick(row)
          },
        },
        {
          value:'loginId',
          text:'로그인ID',
        },
        {
          value:'epid',
          text:'EPID',
        },
        {
          value:'employeeIDNumber',
          text:'사번',
        },
        {
          value:'knoxId',
          text:'Knox ID',
        },
        {
          value:'userName',
          text:'사용자명',
          component: {
            props: ['row', 'value'],
            template:
              `<cmp-user-name-link
                :pageId="'PGE_CMY_00037'"
                :displayType="'1'"
                :displayLanguageId="row.displayLangId"
                :userId="row.userId"
                :knoxId="row.knoxId"
                :loginId="row.loginId"
                :userName="row.userName"
                :userGlobalName="row.userGlobalName"
                :departmentName="row.departmentName"
                :departmentEnglishName="row.departmentEnglishName"
                :type="'link'"
              />`
          },
        },
        {
          value:'userGlobalName',
          text:'사용자 영문명',
        },
        {
          value:'email',
          text:'이메일',
          width:200,
        },
        {
          value:'companyName',
          text:'회사명',
        },
        {
          value:'finalModificationDTM',
          text:'최종수정일',
          width:150,
          customValue: function(value, row) {
            return utils.dateformatToClient(value)
          },
        },
      ],
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: 'SUBTITLE',
          component: tab01,
        },
      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        loginId: '',
        userName: '',
        employeeIDNumber: '',
        userGlobalName: '',
      },
    };
  },
  computed: {},
  watch: {
  },
  datasets: [],
  created() {
    // infinity scroll용 (pagination 사용 시 필요없음)
    this.items = [
      {value: 5, text: '5 per page'},
      {value: 10, text: '10 per page'},
      {value: 15, text: '15 per page'},
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onSearchClick();
      }
    },
    onSearchClick() {
      const dataParams = {
        loginId: this.queryData.loginId,
        userName: this.queryData.userName,
        employeeIDNumber: this.queryData.employeeIDNumber,
        userGlobalName: this.queryData.userGlobalName,
      };
      http.requestTest('get', '/api/v1/common/user-master', {
        query: dataParams,
      }).then(res => {
        this.newDataSet.setData(res.data);
      });
    },
    onResetClick() {
      this.queryData.loginId = '';
      this.queryData.userName = '';
      this.queryData.employeeIDNumber = '';
      this.queryData.userGlobalName = '';
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onExcelDownloadClick() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columns;
      const objGridDataset = this.newDataSet;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `excel_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    onRowSelect(row) {
      if(row) {
        this.selectedGridRowData = row;
      }
    },
    // infinity scroll dropdown 항목 선택 시 grid height 변경
    onPageSizeChange(v) {
      this.$refs.grid.mx_pager.rowsPerPage = v;
      this.options.height =  v * DEFAULT_ROW_HEIGHT;
      this.$nextTick(() => {
        this.$refs.grid.mx_buildViewData();
      });
    },
    onDetailClick(selectedRow) {
      if (selectedRow) {
        utils.goPage('PGE_CMY_00036', {
          userId: selectedRow.userId,
          queryData: this.queryData,
        });
      }
    },
  },
};
</script>
<style scoped>
</style>
